import React, { useRef, useState } from 'react'
import { QRCode } from 'react-qrcode-logo';
import deleteIcon from '../../static/delete_black.png';
import qrBg from '../../static/qrBg.jpg';
import { useSelector } from 'react-redux';
import mergeImages from 'merge-images';
import qrcode from 'qrcode';
import MainLogo from '../../assets/logo.png';
import jsPDF from 'jspdf';
import PDFLogo from '../../static/filePDF.png';
import PngLogo from '../../static/png-file.png';
import CloseButtonLogo from '../../static/close-button.png';
import html2canvas from 'html2canvas';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';

dayjs.extend(utc);
dayjs.extend(timezone);


const StaticQRModal = ({courseId, seminarId, type, closeModal, seminarLogo, courseDetails}) => {
  const pdfRef = useRef(null);
  const handleGeneratePdf = () => {
    const doc = new jsPDF({
      orientation:"landscape",
      unit: 'px',
    });
     
    // Adding the fonts.
    doc.setFont('Inter-Regular', 'normal');

    doc.html(pdfRef.current, {
      async callback(doc) {
        await doc.save(`${courseId}-${seminarId}`);
      },
    });
  };
  const date = dayjs(courseDetails.time).tz("Asia/Jerusalem").format("DD/MM/YYYY");
  const time = dayjs(courseDetails.time).tz("Asia/Jerusalem").format("HH:mm");
  console.log(courseDetails);
  const [loading, setLoading] = useState(true);
  const [qrImage, setQrImage] = useState("");

  const user = useSelector(state => state.user);

 const handleCapture = async (saveAsImage) => {
    if (pdfRef.current) {
      const canvas = await html2canvas(pdfRef.current, {
        allowTaint: true, // Allow images from other origins to be rendered
        useCORS: true,     // Attempt to use CORS for images
        scale: 2
      });

      // You can then use the canvas to get a data URL or download the image
      const imgData = canvas.toDataURL('image/png');
      if(saveAsImage) {
        const link = document.createElement("a");
        link.href = imgData;
        link.download = "capture.jpg";
        return link.click();
      }
      const pdf = new jsPDF({
        orientation:"landscape",
        unit: 'px',
      });
      
      const imgWidth = 610; // A4 width in mm
      const pageHeight = 497; // A4 height in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
      }

      pdf.save(`${courseId}.pdf`);
    }
  };
  
 
  return (
    <div>
      <div className='modal'>
        <div 
          className='relative w-auto my-6 mx-auto max-w-3xl overflow-scroll mt-[20px]'
        >
          <div className="border-2 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none p-9 justify-center items-center overflow-scroll z-40">
            <div dir='rtl' 
              className="relative px-14 flex flex-col  items-start h-full gap-1" 
              ref={pdfRef}

            >
              <h2 className='text-black font-bold text-md '>מספר הרצאה: {courseDetails.courseNumber}</h2>
              <h2 className='text-black font-bold text-md '>מיקום: {courseDetails.location}</h2>
              {courseDetails.lecturer && <h2 className='text-black font-bold text-md '>מרצה: {courseDetails.lecturer}</h2>}
              <div className='w-[50%] flex items-center justify-between'>
              <h2 className='text-black font-bold text-md '>תאריך: {date}</h2>

              <h2 className='text-black font-bold text-md '>שעה: {time}</h2>
              </div>

  
            
              <div className='w-full flex items-center justify-between'>
                <div className='w-[50%] h-full flex flex-col justify-start items-center p-2'>
                  {type === "start" && <QRCode size={300} value={`${window.location.origin}/attendencestart/${courseId}`}/>}
                  {type === "end" && <QRCode size={300} value={`${window.location.origin}/attendenceend/${courseId}`}/>}
                </div>
                <img
                  src={seminarLogo || MainLogo}
                  className='w-[40%] h-full'
                />

              </div>
            </div>
            <div className='flex w-full items-center justify-center gap-2'>
              <button 
                className=' text-white font-bold rounded-lg shadow-md  p-2' 
                onClick={closeModal}
              >
                <img
                  src={CloseButtonLogo}
                  className='w-10'
                />
              </button>
              <button 
                className=' text-white font-bold rounded-lg
                  shadow-md p-2' 
                  onClick={() => handleCapture(false)}
              >
                <img
                  src={PDFLogo}
                  className='w-10'
                /> 
              </button>
              <button 
                className=' text-white font-bold rounded-lg
                  shadow-md p-2' 
                  onClick={() => handleCapture(true)}
              >
                <img
                  src={PngLogo}
                  className='w-10'
                /> 
              </button>
            </div>
          </div>
          
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>

    </div>
  )
}

export default StaticQRModal